import script from "./CardOrderProductionSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./CardOrderProductionSummary.vue?vue&type=script&setup=true&lang=js"

import "./CardOrderProductionSummary.vue?vue&type=style&index=0&id=0afa523b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afa523b"]])

export default __exports__